import ajax from '../utils/ajax'
function loadDataset(id) {
    return ajax.get(`/api/dataset/${id}`).then((resp)=>{
        return resp.result;
    });
}

function updateDataset(dataset){
    return ajax.put(`/api/dataset/`,dataset).then((resp)=>{
        return resp.result;
    });
}

function createDataset(dataset){
    return ajax.post(`/api/dataset`,dataset);
}

function getDatasets(projectId){
    return ajax.get(`/api/dataset`,{
        params:{
            projectId
        }
    }).then((resp)=>{
        return resp.result;
    });
}

function removeDataset(id){
    return ajax.delete(`/api/dataset/${id}`).then((resp)=>{
        return resp.result;
    });
}

export { loadDataset, updateDataset, createDataset, getDatasets, removeDataset };
